import {Button, Menu, MenuButton, MenuItem, MenuList} from '@chakra-ui/react';
import {ChevronDownIcon} from "@chakra-ui/icons";
import "./icondropdownmenu.scss"
import React from "react";

interface IIconDropdownMenu {
    icon: JSX.Element
    title: string
    menuItems: { title: string, action: () => void }[]
    boxTitle?: string
}

const IconDropdownMenu = ({icon, title, menuItems, boxTitle}: IIconDropdownMenu) => {
    return (
        <div className="Icon-Dropdown-Menu">
            <Menu>
                <MenuButton as={Button} rightIcon={<ChevronDownIcon/>}>
                    {icon}
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    {boxTitle ? boxTitle : title}
                </MenuButton>
                <MenuList>
                    {
                        menuItems.map((menuItem, index) => {
                            return (
                                <MenuItem key={index} onClick={menuItem.action}>{menuItem.title}</MenuItem>
                            );
                        })
                    }
                </MenuList>
            </Menu>
        </div>
    )
}

export default IconDropdownMenu